<!--
 * @Author: RYL
 * @Description: 终端选择设备组件
 * @Date: 2020-11-09 16:23:44
 * @LastEditTime: 2021-01-04 11:00:56
-->
<template>
  <div class="device-select">
     <el-dropdown trigger="click" style="width: 100%" placement="bottom-start" ref="dropdown">
      <div class="terminal-input">
        <div v-if="deviceSelect.deviceDid && deviceSelect.deviceSn"  style="height: 26px;line-height: 26px; padding-left: 15px">
           {{deviceSelect.deviceSn}}（{{deviceSelect.deviceName ? deviceSelect.deviceName : 'N/A'}}）
        </div>
        <div 
          v-else 
          style="height: 26px;line-height: 26px; color: #C0C4CC;padding-left: 15px">
          {{$t('lang.Input.placeholder')}}
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
          <div class="select">
            <div class="select-project">
              <el-tree
                lazy
                :highlight-current="true"
                :expand-on-click-node="false"
                @node-click="clickProject"
                :load="loadNode"
                :props="defaultProps">
                <span class="custom-tree-node" slot-scope="{ node }">
                  <span style="font-size: 16px">{{node.label}}</span>
                </span>
              </el-tree>
            </div>
            <div class="select-devices">
              <el-tree
                :highlight-current="true"
                :data="deviceList"
                :props="deviceProps">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <el-radio v-model="deviceSelect" :disabled="data.deviceIsconnected == 3 ? false : true" :label="data" :class="setRadioStyle(data)" @change="deviceChange">
                    <span style="font-size: 16px">
                      <el-tag size="mini" type="success" v-if="data.deviceIsconnected == 3">{{$t('lang.devicelist.connected')}}</el-tag>
                      <el-tag size="mini" type="danger" v-else>{{$t('lang.devicelist.not')}}</el-tag>
                      {{node.label}}（{{data.deviceName ? data.deviceName : 'N/A'}}）
                      </span>
                  </el-radio>
                </span>
              </el-tree>
            </div>
          </div>  
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { projectConfig } from '@/mixins/projectConfig'
import { getListByGroup } from '@/api/cloudMonitor/deviceList'
export default {
  mixins: [projectConfig],
  props: {
    device: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // project: {},
      defaultProps: {
        chirldren: 'children',
        label: 'groupName'
      },
      deviceList: [],
      // 选择的设备
      deviceSelect: {},
      deviceProps: {
        label: 'deviceSn'
      },
    }
  },
  watch: {
    device:{
      immediate: true,
      deep: true,
      handler() {
        this.deviceSelect = this.device
      }
    }
  },
  methods: {
    // 点击项目获取设备
    clickProject(node) {
       let params = {
        pageParam: {
          current: 1,
          size: 99999
        },
        deviceInfo: {
          deviceGid: node.groupId
        }
      }
      this.terminalList = []
      getListByGroup(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.deviceList = data.records
        }
      })
    },
    // 选择设备发生变化
    deviceChange(val) {
      this.$refs.dropdown.hide()
       this.$emit('setDeviceSelect', this.deviceSelect)
    },
    //设置样式
    setRadioStyle(data){
      if(data.deviceDid === this.deviceSelect.deviceDid) {
        this.deviceSelect = data
        return 'isCheck'
      }else{
        return ''
      }
     
    },
  }
}
</script>
<style scoped>
.terminal-input{
  width: 80%;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  min-height: 26px;
  cursor: pointer;
  overflow: hidden;
}
.device-select{
  transform: translateY(5px)
}
.select-project{
  min-width: 150px;
  max-width: 200px;
  max-height: 400px;
  overflow: scroll;
  border-right: 1px solid #b4cee9;
} 
.select-devices{
  min-width: 150px;
  max-width: 300px;
  max-height: 400px;
  overflow: scroll;
  border-right: 1px solid #b4cee9;
}
.select  {
  display: flex;
  width: 100%;
}
.isCheck{
  background-color: #f0f7ff;
}
</style>